import React, { FC, createRef } from 'react';
import { ProductViewer } from '@dp/product-customizer-components';
import { ProductViewerRef } from '@dp/product-customizer-components/dist/src/ProductViewer/ProductViewer.types';
import { getShopRefInStorage } from '../mon-compte/MonCompteAction';
import { ItemCart } from './iCart';
import { getHostApi } from '../../utils';

interface Props {
    item: ItemCart;
    canMove: boolean;
    shopRef: string;
    enabledPostProcessing?: boolean;
}

const CartProductViewer: FC<Props> = ({ canMove, item, shopRef, enabledPostProcessing }): JSX.Element => {
    const ref = createRef<ProductViewerRef>();

    const handleLoad = () => {
        if (item && ref.current && shopRef !== 'ME') {
            const emplacement = item.surfaces[0].surface.emplacement;
            ref.current.setAngle(parseInt(emplacement.angle_3d ?? 0));
        }
    };

    const getHost = (): string => shopRef === 'TH' ? getHostApi() : '';

    const getTextureUrl = (): null|string => {
        const addonVersion = `?v=${new Date().getTime()}`;
        let url = null;
        if (item.with_uploaded_file === 1) {
            url = `${getHost()}/upload-${getShopRefInStorage().toLocaleLowerCase()}/${item.creation_id}/textures/${item.creation_id}.webp${addonVersion}`;
        }
        if (shopRef === 'ME') {
            url = `/images/textures/${item.creation_id}.webp${addonVersion}`;
        }
        return url;
    };

    return (
        <ProductViewer
            ref={ref}
            glbUrl={`${getHost()}/model/${item.article.produit.idProduits}.xs3p`}
            colorId={parseInt(item.article.couleur.idCouleursArticles)}
            textureUrl={getTextureUrl()}
            primaryColor="#FFF"
            disabledCameraControl={!canMove}
            enabledPostProcessing={enabledPostProcessing}
            onLoad={handleLoad}
        />
    );
};

export default CartProductViewer;
